module.exports = __webpack_public_path__ + "img/partnerGreen.70c76157.jpg";